<template>
  <div class="app-login">
    <div class="app-login__header">
      <h3 class="app-login__title">账户登录</h3>
      <p class="app-login__tip">ACCOUNT LOGIN</p>
    </div>
    <div class="app-login__body">
      <el-form class="app-login__form" :model="form" :rules="rules" ref="form" @submit.native.prevent="onSubmit">
        <el-form-item prop="username">
          <el-input type="text" size="small" v-model="form.username" placeholder="账号或手机号">
            <app-svg-icon slot="prefix" icon-class="account"></app-svg-icon>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" size="small" v-model="form.password" placeholder="密码">
            <app-svg-icon slot="prefix" icon-class="lock"></app-svg-icon>
          </el-input>
        </el-form-item>
        <div class="app-login__form-group">
          <el-checkbox v-model="form.rememberMe">自动登录</el-checkbox>
          <router-link class="app-login__forgot" :to="{ name: 'ForgotPassword' }">忘记密码？</router-link>
        </div>
        <div class="app-login__form-submit">
          <el-button native-type="submit" type="primary" size="small" style="width: 100%;">登 录</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLogin',
  data () {
    return {
      form: {
        username: '',
        password: '',
        rememberMe: true
      },
      rules: {
        username: { required: true, message: '请输入账号或手机号', trigger: 'change' },
        password: { required: true, message: '请输入密码', trigger: 'change' }
      }
    }
  },

  methods: {
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.login()
        }
      })
    },

    login () {
      this.$store.dispatch('login', this.form).then(response => {
        const { account } = response.data

        if (account.type === 'customer') {
          this.$router.push({ name: 'LoginNext' })
        } else {
          this.$message({
            type: 'error',
            message: '用户名或密码错误'
          })
        }
      }).catch((error) => {
        console.log('[DEBUG] error', error)
      })
    }
  }
}
</script>

<style lang="scss">
$radius: 4px;

.app-login {
  width: 300px;

  .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
  }

  &__header {
    padding: 20px 30px;
    border-radius: $radius $radius 0 0;
    background-color: $primary-color;
    color: #fff;
  }

  &__title {
    margin-top: 0;
    margin-bottom: 10px;
    font-weight: 400;
  }

  &__tip {
    margin: 0;
    color: #ccc;
    font-size: 14px;
  }

  &__body {
    padding: 30px 30px;
    border-radius: 0 0 $radius $radius;
    background-color: #fff;
  }

  &__form-group {
    font-size: 14px;
  }

  &__form-submit {
    margin-top: 25px;
  }

  &__forgot {
    float: right;
    color: #666;
    font-size: 14px;
  }
}
</style>
